module.exports = __webpack_public_path__ + "static/media/alan26.8d730392.jpg";